import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Editora',
        path: '/biblioteca/bibeditora',
        name: 'bibeditora',
        component: () => import('@/views/biblioteca/bibeditora/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_EDITORANOVO_MENU_1300800799],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Editoras',
        path: '/biblioteca/bibeditora/cadastro/:id?',
        parent: 'bibeditora',
        name: 'bibeditora_create',
        component: () => import('@/views/biblioteca/bibeditora/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_EDITORANOVO_MENU_1300800799],
        },
        goesToMenu: true,
    },
]
